type Problem = {
  status?: number;
  title?: string;
  detail?: string;
  type?: string;
};

type ErrorWithResponse = {
  response?: { status?: number; data?: Problem };
};

export const problemOf = (error: unknown): Problem | undefined =>
  (error as ErrorWithResponse)?.response?.data;

export const problemDetail = (error: unknown): string | undefined => {
  const problem = problemOf(error);
  return problem?.detail ?? problem?.title;
};

export const problemType = (error: unknown): string | undefined =>
  problemOf(error)?.type;

export const statusOf = (error: unknown): number | undefined =>
  (error as ErrorWithResponse)?.response?.status;
